module.exports = __webpack_public_path__ + "static/media/squared.3b40f69c.jpg";